import { useTranslation } from 'react-i18next';

export const useEnumMapper = (
  enumObj: { [key: string]: string | number },
  identifier?: string
) => {
  const { t } = useTranslation();

  return Object.values(enumObj)
    .filter((v) => typeof v === 'string')
    .map((v) => {
      return {
        value: enumObj[v as keyof typeof enumObj].toString(),
        label: t(
          !identifier
            ? `enums.${v as string}`
            : `enums.${(identifier + '.' + v) as string}`,
          v as string
        ),
      };
    });
};

export const useEnumMapperValueAsNumber = (
  enumObj: {
    [key: string]: string | number;
  },
  identifier?: string
) => {
  const { t } = useTranslation();

  return Object.values(enumObj)
    .filter((v) => typeof v === 'string')
    .map((v) => {
      return {
        value: enumObj[v as keyof typeof enumObj],
        label: t(
          !identifier
            ? `enums.${v as string}`
            : `enums.${(identifier + '.' + v) as string}`,
          v as string
        ),
      };
    });
};
